import { GridCustomCellProps } from '@progress/kendo-react-grid';
import dayjs from 'dayjs';
import TimeAgo from 'react-timeago';
import { OrderServiceExceptionViewModel } from "TypeGen/ServiceExceptions/order-service-exception-view-model";
import { dateFormatter } from "utils/utils";

export const OpenedCell = (props: GridCustomCellProps) => {
    const data = props.dataItem as OrderServiceExceptionViewModel;

    if (data.Status >= 120) {
      return <td {...props.tdProps}>
        {data.CreatedByFullName}<br />
        {dateFormatter(data.CreatedDateTime)}
      </td>
    }

    const createdDate = dayjs.utc(data.CreatedDateTime);
    return <td {...props.tdProps}>
      {data.CreatedByFullName}<br />
      <span className={createdDate.isBefore(dayjs().subtract(15, 'minutes')) ? 'text-danger' : ''}>
        <TimeAgo date={createdDate.toDate()} />
      </span>
    </td>
  }